<template>
    <div class="analytics-diamond-completion">
        <div
            v-for="phone in phones[type]" :key="phone.id"
            class="analytics-diamond-completion__phone"
            :class="selectionClass(phone)">
            <span v-if="showPreloader" class="analytics-diamond-completion__preloader"></span>
            <template v-if="!showPreloader">
                <span class="analytics-diamond-completion__phone-value">{{ phone.value }}</span>
                <span class="analytics-diamond-completion__phone-icon"></span>
            </template>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            showPreloader: {
                type: Boolean,
                default: true
            },

            type: {
                type: String,
                default: 'phonemicVowel',
            },

            phones: {
                type: Object,
                default: {
                    phonemicVowel: [
                        {id: 1, value: "/a/", correctness: 100},
                        {id: 2, value: "/e/", correctness: 0},
                        {id: 3, value: "/o/", correctness: 0},
                        {id: 4, value: "/ö/", correctness: 0},
                        {id: 5, value: "/ı/", correctness: 0},
                        {id: 6, value: "/i/", correctness: 0},
                        {id: 7, value: "/u/", correctness: 0},
                        {id: 8, value: "/ü/", correctness: 0}
                    ],
                    phonemicConsonant: [
                        {id: 1, value: "/p/", correctness: 100},
                        {id: 2, value: "/b/", correctness: 0},
                        {id: 3, value: "/t/", correctness: 0},
                        {id: 4, value: "/d/", correctness: 0},
                        {id: 5, value: "/k/", correctness: 0},
                        {id: 6, value: "/g/", correctness: 0},
                        {id: 7, value: "/f/", correctness: 0},
                        {id: 8, value: "/v/", correctness: 0},
                        {id: 9, value: "/s/", correctness: 0},
                        {id: 10, value: "/z/", correctness: 0},
                        {id: 11, value: "/ş/", correctness: 0},
                        {id: 12, value: "/j/", correctness: 0},
                        {id: 13, value: "/h/", correctness: 0},
                        {id: 14, value: "/y/", correctness: 0},
                        {id: 15, value: "/m/", correctness: 0},
                        {id: 16, value: "/n/", correctness: 0},
                        {id: 17, value: "/r/", correctness: 0},
                        {id: 18, value: "/l/", correctness: 0},
                        {id: 19, value: "/ç/", correctness: 0},
                        {id: 20, value: "/c/", correctness: 0}
                    ],
                    phoneticVowel: [
                        {id: 1, value: "[ɑ]", correctness: 100},
                        {id: 2, value: "[a]", correctness: 0},
                        {id: 3, value: "[e]", correctness: 0},
                        {id: 4, value: "[ɛ]", correctness: 0},
                        {id: 5, value: "[æ]", correctness: 0},
                        {id: 6, value: "[o]", correctness: 0},
                        {id: 7, value: "[ɔ]", correctness: 0},
                        {id: 8, value: "[ø]", correctness: 0},
                        {id: 9, value: "[œ]", correctness: 0},
                        {id: 10, value: "[ɨ]", correctness: 0},
                        {id: 11, value: "[i]", correctness: 0},
                        {id: 12, value: "[ɪ]", correctness: 0},
                        {id: 13, value: "[u]", correctness: 0},
                        {id: 14, value: "[ʊ]", correctness: 0},
                        {id: 15, value: "[y]", correctness: 0},
                        {id: 16, value: "[ʏ]", correctness: 0}
                    ],
                    phoneticConsonant: [
                        {id: 1, value: "[k]", correctness: 100},
                        {id: 2, value: "[c]", correctness: 0},
                        {id: 3, value: "[g]", correctness: 0},
                        {id: 4, value: "[ɟ]", correctness: 0},
                        {id: 5, value: "[v]", correctness: 0},
                        {id: 6, value: "[ʋ]", correctness: 0},
                        {id: 7, value: "[z]", correctness: 0},
                        {id: 8, value: "[z̥]", correctness: 0},
                        {id: 9, value: "[x]", correctness: 0},
                        {id: 10, value: "[ç]", correctness: 0},
                        {id: 11, value: "[m]", correctness: 0},
                        {id: 12, value: "[ɱ]", correctness: 0},
                        {id: 13, value: "[n]", correctness: 0},
                        {id: 14, value: "[ŋ]", correctness: 0},
                        {id: 15, value: "[r]", correctness: 0},
                        {id: 16, value: "[ɾ]", correctness: 0},
                        {id: 17, value: "[ɣ]", correctness: 0},
                        {id: 18, value: "[ɬ]", correctness: 0},
                        {id: 19, value: "[l]", correctness: 0}
                    ]
                }
            }
        },
        
        methods: {
            selectionClass(phone){
                return phone.correctness === 100
                       ? 'analytics-diamond-completion--phone-completed'
                       : '';
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-diamond-completion.css"></style>